import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { VendorRegistrationsComponent } from 'src/app/components/vendor-registrations/vendor-registrations.component'
import { MenuItem, MessageService } from 'primeng/api';
import { DatePipe, Location } from '@angular/common';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { first } from 'rxjs';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { AttachmentsZipService } from 'src/app/services/attachments-zip.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-vendor-data',
  templateUrl: './vendor-data.component.html',
  styleUrls: ['./vendor-data.component.scss'],
  providers: [VendorRegistrationsComponent, DatePipe]
})
export class VendorDataComponent implements OnInit {
  vendorDetails: any;
  vendorFormData:any;
  VendorTableData:any;
  VendorTableDataAfterFilter:any;
  vendorAttachmentData:any;
  // basicDetailsForm: FormGroup;
  public tableHeaderName = 'Completed Apps';
  miCompletedReport: MenuItem[];
  imageError: string = 'Document Not Found.';
  // @Input() mobilenumberEmitInput: any;

  public emailId: any;
  public deptRemarks: any;
  public statusList: any = [];
  public selectedStatus: any;

  public objectionTypes: any = [];
  public selectedobjections: any = [];
  public viewType: any = 'action';
  public selectedProg: any = null;
  public componentMasterList: any = [];
  public appStatus: any = null;

  addedCompTableExport: MenuItem[];

  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService,
    private jeService: JEService, 
    private veReg: VendorRegistrationsComponent, 
    private location: Location,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private personalDetalSer: FarmersDetailsService,
    private zipService: AttachmentsZipService,
    private datePipe: DatePipe,
    private vendorService: VendorDashboardService,
  ) {}

  ngOnInit(): void {
    // setTimeout(() => {
    //   this.statusList = [
    //     {
    //       name: 'Approve',
    //       id: 1
    //     },
    //     {
    //       name: 'Reject',
    //       id: 0
    //     }
    //   ]
    // }, 200)

    this.getStatusList();
   
    this.route.queryParams.subscribe(params => {
      const encryptedMobile = params['email'];
      // const viewType = params['viewType'];
      this.viewType = this.cryptoJsService.DecryptData(params['viewType']);
      this.appStatus = this.cryptoJsService.DecryptData(params['status']);

      if (encryptedMobile) {
        this.emailId = this.cryptoJsService.DecryptData(encryptedMobile);
        this.getVendorFullDetailsByEmail(this.emailId);
      }else{
        setTimeout(()=> this.onClickBack(), 1300);
      }
    });

    if(this.viewType == 'viewOnly'){
      this.loadComponentMaster(this.emailId);
    }

    this.addedCompTableExport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.VendorTableDataAfterFilter, `${this.vendorFormData?.Vendor_Name}_(${new Date()})`);
        },
      }
    ];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'MI System Name': d.MI_System_Name, 
          'Category': d.Component_Cat, 
          'Component': d.Component, 
          'Size': d.Component_Size, 
          'Price': d.Price, 
          'CML Sr. No': d.CML_SrNo, 
          'CML Validity': d.CML_Validity, 
          'CML Certificate Path': d.CML_Certificate
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadComponentMaster(emailId) {
    this.loader.start();
    this.vendorService
      .getVendorProgMaster(emailId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.componentMasterList = res;
        },
        error: (err) => {
          this.loader.close();
          this.componentMasterList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectProgramme(){
    this.VendorTableDataAfterFilter = this.VendorTableData.filter(item => item.Program_Id === this.selectedProg?.Program_Id);
  }

  getStatusList() {
    this.loader.start();
    this.personalDetalSer
      .getVendorRegStatusMaster()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.statusList = data;

          } else {
            this.statusList = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Objection Types list not loaded. ${data}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.statusList = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  getObjectionTypeList() {
    let id = this.vendorFormData?.VTId;
    this.loader.start();
    this.personalDetalSer
      .getVendorRegDocTypeMaster(id)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.objectionTypes = data;

          } else {
            this.objectionTypes = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Objection Types list not loaded. ${data}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.objectionTypes = [];

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Error! ${err}`,
          });
        },
      });
  }

  getVendorFullDetailsByEmail(emailId: string) {
    this.jeService.getVendorFullDetailsByEmail(emailId).subscribe({
      next: (data) => {
        this.vendorDetails = data;
        this.vendorFormData = data.personalDetails.$values[0];
        this.VendorTableData = data.componentDetails.$values;
        this.VendorTableDataAfterFilter = data.componentDetails.$values;
        this.vendorAttachmentData = data.attachmentDetails.$values;
        this.getObjectionTypeList();
        // Handle your form display logic here
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
        setTimeout(()=> this.onClickBack(), 1300);
      }
    });
  }
  removeAttachment(index: number) {
    if (confirm('Are you sure you want to remove this attachment?')) {
      this.vendorAttachmentData.splice(index, 1);
    }
  }

  onSubmit(){
    if(this.selectedStatus == null || this.deptRemarks == null || this.deptRemarks == ''){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Status & Enter Remark',
      });
      return;
    }else if(this.selectedStatus == 'Objection' && this.selectedobjections.length == 0){
      this.messageService.add({
        severity: 'warn',
        summary: 'Warn Message',
        detail: 'Select Objection Type',
      });
      return;
    }
    else{
      let reqBody = {
        "Status": this.selectedStatus,
        "remarks": this.deptRemarks,
        "Vendor_Id": this.vendorFormData?.Vendor_Id,
        "objDocIds": this.selectedobjections.map(item => item.Id).join(",")
      }

      this.submitStaus(reqBody);
    }
  }

  submitStaus(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.jeService
      .submitVendorApprovalStatus(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if(res == "Details Updated"){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: `${res}`,
            });
            setTimeout(()=> this.onClickBack(), 1300);
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `${res}`,
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickBack() {
    this.location.back();
  }

  onStatusChange(event){
  }

  downloadZip(){
    let urls = this.vendorAttachmentData.map(item => item.Attachments);
    this.zipService.downloadZip(urls, `${this.vendorFormData?.Vendor_Name} (${this.datePipe.transform(new Date(), 'dd-MM-yyyy')})`);
  }
}